import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderDailyBible from "../../../../src/content/dailybiblereading/donationHeader";
import styles from "../../../../src/content/dailybiblereading/styles";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderDailyBible,
  styles,
  React
};